module.exports = __webpack_public_path__ + "static/screenshot3-781170c3c6a035789fbe3d8697a3cad4.png";